import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials lets the browser send the httpOnly admin session cookie.
// The token itself is never readable from JavaScript.
export const api = axios.create({ baseURL: API, withCredentials: true });

// ----------------------------- Public -----------------------------
export const createLead = (payload) => api.post("/leads", payload).then((r) => r.data);

export const notifyLead = (leadId) => api.post(`/leads/${leadId}/notify`).then((r) => r.data);

export const uploadDocument = (file, leadId) => {
  const form = new FormData();
  form.append("file", file);
  if (leadId) form.append("lead_id", leadId);
  return api
    .post("/documents", form, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};

// ----------------------------- Admin (cookie session) -----------------------------
export const adminLogin = (password) =>
  api.post("/admin/login", { password }).then((r) => r.data);

export const adminLogout = () => api.post("/admin/logout").then((r) => r.data);

export const adminVerify = () => api.get("/admin/verify").then((r) => r.data);

export const adminStats = () => api.get("/admin/stats").then((r) => r.data);

export const adminLeads = (search = "", status = "") => {
  const params = new URLSearchParams();
  if (search) params.set("search", search);
  if (status) params.set("status", status);
  const qs = params.toString();
  return api.get(`/admin/leads${qs ? `?${qs}` : ""}`).then((r) => r.data);
};

export const adminUpdateLead = (leadId, patch) =>
  api.patch(`/admin/leads/${leadId}`, patch).then((r) => r.data);

export const adminDocuments = (leadId = "") =>
  api
    .get(`/admin/documents${leadId ? `?lead_id=${encodeURIComponent(leadId)}` : ""}`)
    .then((r) => r.data);

const triggerBrowserDownload = (blobData, filename) => {
  const url = window.URL.createObjectURL(new Blob([blobData]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename || "document");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const downloadDocument = (docId, filename) =>
  api
    .get(`/admin/documents/${docId}/download`, { responseType: "blob" })
    .then((r) => triggerBrowserDownload(r.data, filename));
